import { render, staticRenderFns } from "./ReturnAndExchangePackage.vue?vue&type=template&id=62e291c9"
import script from "./ReturnAndExchangePackage.vue?vue&type=script&lang=js"
export * from "./ReturnAndExchangePackage.vue?vue&type=script&lang=js"
import style0 from "./ReturnAndExchangePackage.vue?vue&type=style&index=0&id=62e291c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports